//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ["fileOld", "file_type"],
    methods: {
        downloadFile() {
            window.open(
                this.$store.state.url.URL_APP+'uploads/'+this.fileOld,
            '_blank' // <- This is what makes it open in a new window.
            );
        }
    },
}
